import React from "react";
import { AgGridReact } from "ag-grid-react";
import { Skeleton } from "@mui/material";
import "@mui/icons-material/QueryBuilder";
import useTitanApp from "../../../../../../../../hooks/useTitanApp";

const ToBeClaimedSkeletonLoader = () => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  const gridOptions = {
    columnDefs: [
      {
        headerName: "",
        minWidth: 50,
      },
      {
        headerName: "Patient Name",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Telephone Number",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Date of Birth",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Service Name",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Drug Name",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Completed By",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Engagement Date",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Intervention Date",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Intervention Notes",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "FollowUp Date",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Follow-up Notes",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "NHS Number",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Address",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
      {
        headerName: "Orbit",
        minWidth: 200,
        cellRenderer: () => <SkeletonCellRenderer />,
      },
    ],
    rowData: new Array(10).fill(null),
    defaultColDef: {
      resizable: true,
      flex: 1,
      minWidth: 120,
    },
  };

  return (
    <div
      className={`listview-grid listview-skeleton-grid claimed-skeleton ${
        darkMode ? "ag-theme-quartz-dark" : "ag-theme-quartz"
      }`}
    >
      <AgGridReact gridOptions={gridOptions} />
    </div>
  );
};

const SkeletonCellRenderer = ({ value }) => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  return (
    <Skeleton
      animation="wave"
      sx={{
        bgcolor: darkMode ? "grey.800" : "",
        width: "100%",
        height: "100%",
      }}
    />
  );
};

export default ToBeClaimedSkeletonLoader;
